<template>
    <b-card>
        <div class="position-relative table-responsive">
            <table class="table table-sm">
                <thead>
                    <tr>
                        <th>Navn</th>
                        <th>Pris</th>
                        <th>Auto antal</th>
                        <th></th>
                    </tr>
                </thead>

                <tr>
                    <td>
                        <FormGroup label="Attribut" rules="">
                            <template #input="{state}">
                                <v-select v-model="newItem.attribute" :options="attributes" @search="fetchAttributes" placeholder="Vælg attribut" :filterable="false" append-to-body>
                                    <template slot="option" slot-scope="option">
                                        {{ option.name }}
                                    </template>
                                    <template slot="selected-option" slot-scope="option">
                                        {{ option.name }}
                                    </template>
                                </v-select>
                            </template>
                        </FormGroup>
                    </td>
                    <td>
                        <FormGroup v-model="newItem.price" label="Pris" rules=""></FormGroup>
                    </td>
                    <td>
                        <b-form-checkbox class="mt-8" v-model="newItem.multiplyQuantity" switch></b-form-checkbox>
                    </td>
                    <td class="text-right">
                        <b-button @click="addOption" variant="outline-success" class="py-3 px-2">
                            <feather-icon icon="PlusIcon" size="16" class="mx-6 my-2" />
                        </b-button>
                    </td>
                </tr>

                <draggable tag="tbody" v-model="options" class="cursor-move">
                    <tr v-for="(item, key) in options" :key="key + '-' + item.attributeId">
                        <td>
                            {{item.name}}
                        </td>
                        <td>
                            {{item.price}}
                        </td>
                        <td>
                            <feather-icon v-if="item.multiplyQuantity" icon="CheckCircleIcon" size="18" />
                            <feather-icon v-else icon="CircleIcon" size="18" />
                        </td>
                        <td class="text-right">
                            <b-button @click="deleteOption(key)" variant="outline-danger" class="py-3 px-2 ml-7">
                                <feather-icon icon="TrashIcon" size="16" class="mx-6 my-2" />
                            </b-button>
                        </td>
                    </tr>
                </draggable>
            </table>

        </div>

    </b-card>

</template>

<script>
    export default {
        components: {},
        data: () => ({
            newItem: {
                price: 0,
                multiplyQuantity: false,
                attribute: null
            },
            attributes: []
        }),
        props: {
            value: null,
        },
        computed: {
            options: {
                get() {
                    return this.value
                },
                set(val) {
                    this.$emit('input', val)
                }
            }
        },
        created() {
            this.fetchAttributes("", () => { })
        },
        mounted() { },
        methods: {
            addOption() {
                this.options.push({
                    name: this.newItem.attribute.name,
                    attributeAlias: this.newItem.attribute.alias,
                    attributeId: this.newItem.attribute.id,
                    price: this.newItem.price,
                    multiplyQuantity: this.newItem.multiplyQuantity,
                })

                this.newItem = {
                    price: 0,
                    multiplyQuantity: false,
                    attribute: null
                }
            },
            deleteOption(key) {
                this.options.splice(key, 1)
            },
            fetchAttributes(search, loading) {
                loading(true)

                this.$http.get("/api/attributes", {
                    params: {
                        search: search,
                        exclude: this.editing ? this.id : null
                    }
                }).then(x => {
                    this.attributes = x.data
                    loading(false)
                })
            },
        },
    }
</script>